import { render, staticRenderFns } from "./MyApp.vue?vue&type=template&id=7277387d&"
import script from "./MyApp.vue?vue&type=script&lang=js&"
export * from "./MyApp.vue?vue&type=script&lang=js&"
import style0 from "./MyApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports